import type { EstadoRebatimentoPainel } from '../../dominio/didatico/rebatimentoPainel'
import type { PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'
import { deArray } from '../../dominio/geometria/vetor3'
import { Barra } from '../componentes/Barra'
import { FaceDeCorte } from '../veiculo/Seccionado'
import type { IdPortaOficina } from './zonasOperacaoPorta'
import { pontosRebatimentoPainel } from './zonasRebatimentoPainel'

export function ColunaARebatida3D({ perfil, idPorta, estado, deslocamento }: {
  perfil: PerfilVeiculo; idPorta: IdPortaOficina; estado: EstadoRebatimentoPainel; deslocamento: number
}) {
  const { coluna, yBase, yMedio } = pontosRebatimentoPainel(perfil, idPorta)
  const id = `colunaA${idPorta.endsWith('Esquerda') ? 'Esquerda' : 'Direita'}`
  const folgaBase = estado.corteAlivio ? 0.015 : 0
  const folgaMedia = estado.corteMedio ? 0.015 : 0
  const trechos = [
    [perfil.topoSoleiraY - 0.03, yBase - folgaBase, 0],
    [yBase + folgaBase, perfil.cinturaY, deslocamento],
    [perfil.cinturaY, yMedio - folgaMedia, deslocamento],
    [yMedio + folgaMedia, perfil.tetoY, 0],
  ]
  return <group name="coluna-a-rebatimento">
    {trechos.map(([de, ate, dz], i) => <Barra key={i} id={id} de={deArray(coluna(de, dz))} para={deArray(coluna(ate, dz))} largura={0.10} espessura={0.11} />)}
    {estado.corteAlivio && <>
      <FaceDeCorte posicao={coluna(yBase - folgaBase)} eixo="y" raio={0.052} />
      <FaceDeCorte posicao={coluna(yBase + folgaBase, deslocamento)} eixo="y" raio={0.052} />
    </>}
    {estado.corteMedio && <>
      <FaceDeCorte posicao={coluna(yMedio - folgaMedia, deslocamento)} eixo="y" raio={0.052} />
      <FaceDeCorte posicao={coluna(yMedio + folgaMedia)} eixo="y" raio={0.052} />
    </>}
  </group>
}
